import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumb from "@/components/base/Breadcrumb";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import FeedbackForm from "./components/FeedbackForm";

const values = [
  {
    icon: "ri-emotion-happy-line",
    title: "快乐优先",
    desc: "小黄人带给我们的从来都很简单——就是想笑。所以无论是资讯还是影评，我们都希望读起来轻松、有趣。",
  },
  {
    icon: "ri-shield-check-line",
    title: "真实可靠",
    desc: "影片资料来自公开渠道整理，影评来自真实观影感受。我们不做夸张的标题党，只提供值得一读的内容。",
  },
  {
    icon: "ri-hearts-line",
    title: "陪伴影迷",
    desc: "从最新上映到经典回顾，我们希望成为影迷了解小黄人世界时，一个随时可以回来看看的地方。",
  },
];

const services = [
  { icon: "ri-film-line", label: "完整片库", desc: "动画长片与番外短片一站收录" },
  { icon: "ri-newspaper-line", label: "最新资讯", desc: "上映动态与幕后花絮持续更新" },
  { icon: "ri-chat-quote-line", label: "真诚影评", desc: "来自影迷与评人的多角度观点" },
  { icon: "ri-heart-line", label: "收藏功能", desc: "把喜欢的影片和文章存进本地收藏" },
];

export default function About() {
  useDocumentMeta(
    "关于我们 - 小黄人电影内容站介绍与联系方式 | 小黄人电影",
    "了解小黄人电影内容站的定位、品牌理念与联系方式，欢迎通过反馈表单与我们交流内容建议与合作意向。"
  );
  return (
    <SiteLayout>
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-10">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于小黄人电影
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            一个由影迷搭建、为影迷服务的小黄人系列内容站，认真整理每一部影片的资料，也认真写下每一次观后的感受。
          </p>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        {/* intro */}
        <section className="grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr_1fr] lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-semibold text-secondary-800">
              <i className="ri-flag-2-line"></i>
              我们的故事
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              因为喜欢小黄人，我们想把它讲得更好
            </h2>
            <div className="mt-5 space-y-4 text-[15px] leading-8 text-foreground-700">
              <p>
                小黄人电影成立于一群影迷的自发分享。我们注意到，关于小黄人系列的信息常常零散地散落在各处，想找一部影片的剧情、角色或相关资讯，往往要翻好几个页面。
              </p>
              <p>
                于是我们决定把这些内容整理到一起：完整的影片资料、通俗易懂的剧情介绍、幕后的有趣故事，还有来自不同影迷的真实影评。希望你在了解小黄人世界的时候，能少一点搜索，多一点快乐。
              </p>
              <p>
                本站为动画影视内容演示站点，所有内容基于公开资料整理，用于展示网站功能与阅读体验，与影片版权方无隶属关系。
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {services.map((item) => (
              <div
                key={item.label}
                className="rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 text-sm font-bold text-foreground-950">{item.label}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* values */}
        <section className="mt-16">
          <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className="ri-compasses-2-line"></i>
            </span>
            我们的品牌理念
          </h2>
          <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-3">
            {values.map((value) => (
              <div
                key={value.title}
                className="rounded-2xl border border-background-200 bg-background-50 p-6"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
                  <i className={`${value.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-5 text-lg font-bold text-foreground-950">{value.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* contact */}
        <section className="mt-16 grid grid-cols-1 gap-8 lg:grid-cols-[380px_1fr]">
          <div>
            <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-customer-service-2-line"></i>
              </span>
              联系我们
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              如果你有内容建议、纠错反馈或合作意向，欢迎通过右侧表单留言，也可以通过以下方式找到我们。
            </p>
            <ul className="mt-6 space-y-3">
              {[
                { icon: "ri-mail-line", label: "邮箱", value: "hello@minion-movie.demo" },
                { icon: "ri-wechat-line", label: "微信公众号", value: "小黄人电影" },
                { icon: "ri-time-line", label: "回复时间", value: "工作日 24 小时内" },
              ].map((item) => (
                <li
                  key={item.label}
                  className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-4 py-3.5"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-background-100 text-foreground-600">
                    <i className={`${item.icon} text-base`}></i>
                  </span>
                  <span>
                    <span className="block text-xs text-foreground-500">{item.label}</span>
                    <span className="mt-0.5 block text-sm font-medium text-foreground-900">
                      {item.value}
                    </span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <FeedbackForm />
        </section>

        {/* copyright */}
        <section className="mt-16 rounded-2xl bg-primary-500 p-6 md:p-8">
          <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950">
            <i className="ri-copyright-line"></i>
            版权声明
          </h2>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-900/85">
            本站为动画影视内容演示站点，站内影片名称、角色与相关介绍均为基于公开资料的整理与演绎，仅用于内容展示与阅读体验演示。小黄人及相关影视作品的版权归其版权方所有，本站与版权方无任何隶属关系。如需转载本站原创影评内容，请注明出处。
          </p>
          <p className="mt-4 text-xs text-foreground-900/70">
            © 2026 小黄人电影 · 保留所有权利（演示站点）
          </p>
        </section>
      </div>
    </SiteLayout>
  );
}